import {
    Button, Card, CardContent, Grid,
    Paper
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import classNames from 'classnames';
import MUIDataTable from "mui-datatables";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import transactionEmptyImg from "../../../../assets/diesel-card-transaction-empty-state.png";
import ErrorIconRed from '../../../../assets/transaction-error-icon-red.svg';
import * as logger from "../../../../logger";
import { defaultPageNo, defaultPageSize } from '../../../../paginationVariables';
import {
    updateChatView
} from "../../../../store/actions/userActionCreators";
import { getDieselCardTransactionDetails, getSingleDieselCard } from "../../../../store/actions/vehicleActionCreator";
import { dieselCardTableHeight } from "../../../../styleVariables";
import { numberFormat, numberFormatPaisa,getVehicleNumberValuesDWeb } from "../../../../utils/utils";
import FuelPumpSearch from "../../../components/DieselCardComponents/FuelBunkFinder";
import DieselCardDetails from "../../../components/DieselCardComponents/SingleDieselCard/DieselCardDetails";
import DieselConsumptionSideBar from "../../../components/RightSideBar/DieselCardSideBar/DieselConsumptionSideBar";
import DieselCardRechargeSideBar from "../../../components/RightSideBar/DieselCardSideBar/RechargeSideBar";
import TransactionDetailSideBar from "../../../components/RightSideBar/TransactionDetailsSideBar";
import { RechargeFastag, TransactionHistory, TransactionPending } from '../../../components/TopCard/icons';
import { SingleDieselCardCss as useStyles } from './SingleDieselCardCss';
import RewardConsumptionDialog from '../../../components/Verfication/RewardConsumptionDialog';
import SuccessDialog from '../../../components/Verfication/SuccessDialog';
import FailureDialog from '../../../components/Verfication/FailureDialog';
import { getPaymentStatus } from '../../../../store/actions/OnlinePaymentActionCreators';

const SingleDieselCard = ({ user,dispatchGetPaymentStatus, dispatchGetSingleDieselCardDetails, dispatchGetDieselCardTransactionDetails, vehicle, dispatchChatView }) => {

    let location = useLocation();
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    let rewardAmountUsed = params["rewardAmountUsed"];
    const queryParams = new URLSearchParams(window.location.search)

    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [dieselCardConfig, setDieselCardConfig] = useState({});
    const [rechargeSideBarOpen, setRechargeSideBarOpen] = useState(false);
    const [truckDetails, setTruckDetails] = useState({});
    const [singleDieselCardDetails, setSingleDieselCardDetails] = useState({});
    const [defaultRechargeAmount, setDefaultRechargeAmount] = useState(null);
    const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState({});
    const [dieselConsumptionSideBarOpen, setDieselConsumptionSideBarOpen] = useState(false);
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [rewardConsumption, setRewardConsumption] = useState(false);
    const [defaultData, setDefaultData] = useState(null);
    const [rewardAmount, setRewardAmount] = useState(0);
    const getPaymentStatus = (type) => {
        switch (type) {
            case "SUCCESS":
                return <div className={classes.successDiv}>
                    <CheckCircleIcon className={classes.successIcon} />
                    <div className={classes.headerTxt}>Diesel Recharge Successful</div>
                </div>
            case "PENDING":
                return <div className={classes.pendingDiv}>
                    <TransactionPending className={classes.pendingIcon} />
                    <div className={classes.headerTxt}>Diesel Recharge Pending</div>
                </div>
            case "FAILED":
                return <div className={classes.failedDiv}>
                    <img src={ErrorIconRed} className={classes.imgV2} />
                    <div className={classes.headerTxtError}>Diesel Recharge Failed</div>
                </div>
            default:
                return ""
        }
    }

    let pathName = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = pathName && pathName[pathName.length - 2] ? pathName[pathName.length - 2] : "";
    let brokerId = pathName && pathName[pathName.length - 1] ? pathName[pathName.length - 1] : "";

    const requestData = {
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        vehicleId: vehicleId,
        brokerId: brokerId
    }
    const goToSingleDieselCard = (truckInfo) => {
        if (truckInfo && truckInfo.vehicleId) {
            history.push({
                pathname: `/diesel-card/single-diesel-card/${truckInfo && truckInfo.vehicleId ? truckInfo.vehicleId : ""}/${truckInfo && truckInfo.fuelCardBrokerId ? truckInfo.fuelCardBrokerId : ""}`,
                state: {
                    id: 1,
                    pageTitle: "Diesel Card",
                    vehicleNumber:truckInfo&&truckInfo.vehicleNumber?getVehicleNumberValuesDWeb(truckInfo.vehicleNumber) : []
                }
            })
        }
    }
    useEffect(() => {

        vehicle.singleDieselCardInfo = {}

        dispatchGetSingleDieselCardDetails(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Diesel Card Dweb", "Get Single Diesel Card Details Successfull");

                    if (orderId) {
                        /*if (queryParams.has('order_id')) {
                            queryParams.delete('order_id')
                            history.replace({
                                search: queryParams.toString(),
                            })
                        }*/
                        if (orderId) {
                            dispatchGetPaymentStatus({
                                orderId: orderId
                            }, (response) => {
                                if (response && response.status && response.status.code == 200) {
                                    if (response.response.message == "Transaction Failed.") {
                                        handleFailureOpen()
                                        setTimeout(() => {
                                            handleFailureClose(data)
                                        }, 3000);
                                    } else if (response.response && response.response.rewardAmountUsed && Number(response.response.rewardAmountUsed) != 0) {
                                        setRewardAmount(response.response.rewardAmountUsed)
                                        handleRewardsOpen()
                                        setTimeout(() => {
                                            handleRewardsClose(data)
                                        }, 3000);
                                    } else {
                                        handleSuccessOpen()
                                        setTimeout(() => {
                                            handleSuccessClose(data)
                                        }, 3000);
                                    }
                                } else {
                                    handleFailureOpen()
                                    setTimeout(() => {
                                        handleFailureClose(data)
                                    }, 3000);
                                }
                            }, () => {
                                handleFailureOpen();
                                setTimeout(() => {
                                    handleFailureClose(data)
                                }, 3000);
                            })
                        }
                    }
                    if(rewardAmountUsed){
                        handleRewardsOpen()
                        setTimeout(() => {
                            handleRewardsClose(data)
                        }, 3000);
                    }

                }
            },
            () => {
                logger.log("Single Diesel Card Dweb", "Get Single Diesel Card Details Failed");
            }
        )

    }, []);

    useEffect(() => {

        if (user && user.fuelCardConfig) {
            setDieselCardConfig(user.fuelCardConfig)
        }

    }, [user.fuelCardConfig]);

    useEffect(() => {

        if (vehicle && vehicle.singleDieselCardInfo) {
            setSingleDieselCardDetails(vehicle.singleDieselCardInfo)
        }

    }, [vehicle.singleDieselCardInfo])

    useEffect(() => {

        const parentElement = document.getElementById("transaction-table");
        if (parentElement) {

            if (document.getElementById("transaction-table").firstChild) {
                document.getElementById("transaction-table").firstChild.style.height = "100%";
                document.getElementById("transaction-table").firstChild.style.boxShadow = "none";

                if (document.getElementById("transaction-table").firstChild.children[1]) {
                    document.getElementById("transaction-table").firstChild.children[1].style.minHeight = "82%";
                }

            }
        }

    }, [singleDieselCardDetails])

    const classes = useStyles();

    const muiColumns = [
        {
            name: 'id',
            label: "Payment Date",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    if (rowIndex === muiData.length - 3) {

                        return (
                            <>
                                <Waypoint
                                    onEnter={() => {
                                        if (currentPageNo < singleDieselCardDetails.maxPage) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div className={classes.fw500}>{data && data.event_params && data.event_params[0] ? data.event_params[0] : ""}</div>
                            </>
                        )

                    } else {
                        return (
                            <>
                                <div className={classes.fw500}>{data && data.event_params && data.event_params[0] ? data.event_params[0] : ""}</div>
                            </>
                        )
                    }
                }
            }
        },
        {
            name: 'id',
            label: "Transaction Details",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    return (
                        <div>
                            {data && data.event_type && (data.event_type).toLowerCase() == "refill" &&
                                <>
                                    <div>{data.brokerName}</div>
                                    <div className={classes.eventName} >{data.event_name}</div>
                                </>
                            }
                            {data && data.event_type && (data.event_type).toLowerCase() == "recharge" &&
                                <>
                                    {(data.transactionId || data.paymentMode) ?
                                        (
                                            <>
                                                <div>{data && data.transactionId ? data.transactionId : "--"}</div>
                                                <div className={classes.eventName}>{data && data.paymentMode ? data.paymentMode : "--"}</div>
                                            </>
                                        ) :
                                        (
                                            <div>{data && data.event_name ? data.event_name : ""}</div>
                                        )
                                    }
                                </>
                            }
                        </div>
                    )
                }
            }
        },
        {
            name: 'amount',
            label: "Amount",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    return (
                        <>
                            {data && "amount" in data &&
                                <>
                                    {data && data.event_type && (data.event_type).toLowerCase() == "refill" ?
                                        <div className={classes.amountLoss}><span className={classes.fs12}>-</span> {numberFormatPaisa(data.amount)}</div>
                                        :
                                        <div className={data.amount > 0 ? classes.amountProfit : classes.fwBold}> {data.amount > 0 && <span className={classes.fs12}>+</span>} {numberFormat(data.amount)}</div>
                                    }
                                </>
                            }
                        </>
                    )
                }
            }
        },
        {
            name: 'id',
            label: "Action",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    return (
                        <>
                            {data && data.event_type && (data.event_type).toLowerCase() == "refill" &&
                                <div>
                                    <Button variant="outlined" className={classes.viewMapButton} onClick={() => handleTransactionDetailsClick(data, "viewInMap")}>
                                        View in Map
                                    </Button>
                                </div>
                            }
                            {/* {data && data.event_type && (data.event_type).toLowerCase() == "recharge" &&
                                <div>
                                    <Button variant="contained" className={classes.rechargeButton} onClick={() => handleRechargeClick(data.amount)}>Recharge Again</Button>
                                </div>
                            } */}
                        </>
                    )
                }
            }
        }
    ]

    const muiData = singleDieselCardDetails && singleDieselCardDetails.transactionLogs ? singleDieselCardDetails.transactionLogs : [];
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: dieselCardTableHeight,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        onRowClick: (rowData, rowMeta) => {
        },
        onCellClick: (colData, cellMeta) => {

            const seletedRow = muiData && muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] ? muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] : {}

            if (seletedRow && seletedRow.event_type && seletedRow.event_type.toLowerCase() != "refill") {
                if (cellMeta.colIndex != 3) {
                    handleTransactionDetailsClick(seletedRow);
                }
            }

            if (seletedRow && seletedRow.event_type && seletedRow.event_type.toLowerCase() == "refill") {
                handleTransactionDetailsClick(seletedRow, "viewInMap")
            }

        },
        onSearchClose: () => {
        },
        textLabels: {
            body: {
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };
    const handleRewardsOpen = () => {
        setRewardConsumption(true)
    }
    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = (data) => {
        setSuccessCreation(false)
        goToSingleDieselCard(data && data.response ? data.response : null)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = (data) => {
        setFailureCreation(false)
        goToSingleDieselCard(data && data.response ? data.response : null)
    }
    const handleRewardsClose = (data) => {
        setRewardConsumption(false)
        /*if (queryParams.has('rewardAmountUsed')) {
            queryParams.delete('rewardAmountUsed')
            history.replace({
                search: queryParams.toString(),
            })
        }*/
        goToSingleDieselCard(data && data.response ? data.response : null)

    }
    const getPaginatedData = () => {
        const dieselCardReqData = {
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            vehicleId: vehicleId,
            brokerId: brokerId,
            merge: true
        };

        dispatchGetSingleDieselCardDetails(dieselCardReqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Diesel Card Dweb", "Get Single Diesel Card Details Successfull");
                }
            },
            () => {
                logger.log("Single Diesel Card Dweb", "Get Single Diesel Card Details Failed");
            }
        )

    }


    const handleHelpRedirection = () => {
        window.open("https://www.youtube.com/embed/" + (singleDieselCardDetails && singleDieselCardDetails.s3LinkForVideo ? singleDieselCardDetails.s3LinkForVideo : ""), "_blank")
    }

    const handleRechargeClick = (amount) => {
        setRechargeSideBarOpen(true);
        setDefaultRechargeAmount(amount);
        if (vehicle && vehicle.singleDieselCardInfo) {
            setTruckDetails(vehicle.singleDieselCardInfo)
        }
    }

    const handleRechargeSideBarClose = () => {
        setRechargeSideBarOpen(false);
    }

    const handleTransactionDetailsClick = (seletedRow, flowText) => {

        const requestData = {
            eventType: seletedRow && seletedRow.event_type ? seletedRow.event_type : "",
            transactId: seletedRow && seletedRow.id ? seletedRow.id : ""
        }

        dispatchGetDieselCardTransactionDetails(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Diesel Card Dweb", "Get Diesel Card Transaction Successfull");
                    if (flowText == "viewInMap") {
                        setDieselConsumptionSideBarOpen(true);
                    } else {
                        setTransactionDetails(data.response);
                        setTransactionDetailsOpen(true);
                    }
                }
            },
            () => {
                logger.log("Single Diesel Card Dweb", "Get Diesel Card Transaction Failed");
            }
        )
    }

    const handleTransactionDetailsClose = () => {
        setTransactionDetailsOpen(false);
        dispatchChatView(true);
    }

    const handleConsumptionSideBarClose = () => {
        setDieselConsumptionSideBarOpen(false);
    }

    return (
        <>
            <Grid container className={classes.gridContainerV1} wrap="nowrap" >

                <Grid container direction="column" wrap="nowrap" className={classes.gridSubContainerV1}>
                    {/* ********************************** Diesel Card Details ********************************** */}
                    <Grid item>
                        <DieselCardDetails />
                    </Grid>

                    {/* ********************************** Transaction History ********************************** */}
                    <Grid item className={classes.mt8} style={{ height: '100%' }}>

                        <Card raised={false} className={classes.transactionHistoryCard} style={{ height: '100%' }}>
                            <CardContent className={classes.cardContentV1} style={{ height: '100%' }}>
                                <div className={classes.divAlignV2}>
                                    <TransactionHistory className={classes.tableTitleIcon} />
                                    <div className={classes.historyText}>Transaction History</div>
                                </div>

                                {singleDieselCardDetails && singleDieselCardDetails.transactionLogs && singleDieselCardDetails.transactionLogs.length == 0 &&
                                    <div className={classes.divEmptyContainer}>
                                        <img src={transactionEmptyImg} />
                                        <div className={classes.emptyText}>All Recharge and Consumption details related to this Diesel card will be shown here</div>
                                        {/* <Button variant='contained' startIcon={<RechargeFastag className={classes.fsV1} />} className={classes.dieselCardRecharge} onClick={() => handleRechargeClick()}>
                                            Recharge
                                        </Button> */}
                                    </div>
                                }
                                {singleDieselCardDetails && singleDieselCardDetails.transactionLogs && singleDieselCardDetails.transactionLogs.length > 0 &&
                                    <div className={classes.mt28} style={{ height: '100%' }} id="transaction-table">
                                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                                    </div>
                                }
                            </CardContent>
                        </Card>

                    </Grid>
                </Grid>

                <Grid container direction="column" wrap="nowrap" className={classes.fitContent}>

                    {/* ********************************** Help Card ********************************** */}
                    {/* <Grid item className={classes.fitContent}>
                        <Card className={classes.helpCard} onClick={() => handleHelpRedirection()}>
                            <CardContent className={classes.noPadding}>
                                <div className={classes.divAlignV1}>
                                    <div className={classes.divAlignV2}>
                                        <div className={classes.questionOuterDiv}>
                                            <div className={classes.questionInnerDiv} >?</div>
                                        </div>

                                        <div className={classes.helperText}>How Diesel card Works</div>
                                    </div>
                                    <div>
                                        <ChevronRightIcon className={classes.rightIcon} />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid> */}

                    {/* ********************************** Fuel Pump Search ********************************** */}
                    {dieselCardConfig && dieselCardConfig.redirect_to_fuel_pump_finder &&
                        <Grid item className={classes.mt8}>
                            <FuelPumpSearch />
                        </Grid>
                    }
                </Grid>

            </Grid>

            {/* **************************** Recharge sidebar **************************** */}
            {rechargeSideBarOpen && <DieselCardRechargeSideBar rightSideBarOpen={rechargeSideBarOpen} onClose={handleRechargeSideBarClose} truckInfo={truckDetails} defaultAmount={defaultRechargeAmount} />}

            {/* **************************** Transaction Details Sidebar **************************** */}
            {transactionDetailsOpen &&
                <TransactionDetailSideBar
                    sideBarTitle="Transaction Details"
                    rightSideBarOpen={transactionDetailsOpen}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleTransactionDetailsClose}
                    showDownloadButtonBlack={false}
                >

                    <Paper className={classes.paymentCard}>
                        {getPaymentStatus(transactionDetails && transactionDetails.transaction_status ? transactionDetails.transaction_status : "")}
                        <div className={classes.divContent}>

                            <div className={classes.divAlignV1}>
                                <div>
                                    <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Payment Date</div>
                                    <div className={classNames(classes.detailsText, classes.textAlignLeft)}>{transactionDetails && transactionDetails.transactionDate ? transactionDetails.transactionDate : "--"}</div>
                                </div>
                                <div>
                                    <div className={classNames(classes.titleV1, classes.textAlignRight)}>Recharge Amount</div>
                                    <div className={classNames(classes.detailsText, classes.textAlignRight)}>{transactionDetails && transactionDetails.amount ? numberFormat(transactionDetails.amount) : "--"}</div>
                                </div>
                            </div>

                            <div className={classNames(classes.divAlignV1, classes.mt16)}>
                                <div>
                                    <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Order ID</div>
                                    <div className={classNames(classes.detailsText, classes.textAlignLeft)}>{transactionDetails && transactionDetails.orderId ? transactionDetails.orderId : "--"}</div>
                                </div>
                                <div>
                                    <div className={classNames(classes.titleV1, classes.textAlignRight)}>Mode of Payment</div>
                                    <div className={classNames(classes.detailsText, classes.textAlignRight)}>{transactionDetails && transactionDetails.paymentMode ? transactionDetails.paymentMode : "--"}</div>
                                </div>
                            </div>

                            <div className={classNames(classes.mt16)}>
                                <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Transaction ID</div>
                                <div className={classNames(classes.detailsText, classes.textAlignLeft)}>{transactionDetails && transactionDetails.transactionId ? transactionDetails.transactionId : "--"}</div>
                            </div>

                        </div>

                        {/* <div className={classes.divContainer}>
                            <Button variant="outlined" className={classes.rechargeAgainButton} onClick={() => handleRechargeClick(transactionDetails && transactionDetails.amount ? transactionDetails.amount : 0)}>Recharge Again</Button>
                        </div> */}
                    </Paper>

                </TransactionDetailSideBar>
            }
            {successCreation && <SuccessDialog selectedValue={defaultData} open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog selectedValue={defaultData} open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {dieselConsumptionSideBarOpen && <DieselConsumptionSideBar open={dieselConsumptionSideBarOpen} onClose={() => handleConsumptionSideBarClose()} />}
            {rewardConsumption && <RewardConsumptionDialog selectedValue={null}  open={rewardConsumption} subTitle={numberFormat(Number(rewardAmountUsed?rewardAmountUsed:rewardAmount!=0?rewardAmount:0))} title={"You Saved"} onClose={handleRewardsClose} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleDieselCardDetails: (data, onSuccess, onError) => { dispatch(getSingleDieselCard(data, onSuccess, onError)) },
    dispatchGetDieselCardTransactionDetails: (data, onSuccess, onError) => {
        dispatch(getDieselCardTransactionDetails(data, onSuccess, onError))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(SingleDieselCard);
